export enum PolicyDecisionConditionCategoryTypes {
    RISK = "risk",
    VERIFICATION = "verification",
    CONTROL = "control"
}